import { useNavigate, useParams } from "react-router-dom";
import * as L from "leaflet";

import { useCase } from "src/hooks/useCase";
import { Pane } from "src/components/Pane";
import { PoiCreatePage } from "./PoiCreatePage";
import { PoiEditPage } from "./PoiEditPage";

interface Props {
  map: L.Map;
}

export function PoiPage(props: Props) {
  const navigate = useNavigate();
  const { caseId = "", poiId = ""} = useParams<{ caseId: string; poiId: string }>();
  const { data: acase } = useCase(caseId);

  function handleClose() {
    if (!acase) return null;
    navigate(`/cases/${acase.id}/pois`);
  }

  return render();

  function render() {
    if (poiId === "new") {
      return (
        <Pane>
          <PoiCreatePage onClose={handleClose} {...props} />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <PoiEditPage key={`${caseId}-${poiId}`} onClose={handleClose} {...props} />
      </Pane>
    );
  }
}
